import ShortNovelasClipsListItem from './ShortNovelasClipsListItem';

export default ShortNovelasClipsListItem;
